function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Hidden } from "../styled/Hidden";
import { PointerOnHover } from "../styled/PointerOnHover";
import styled from "styled-components";
import _ from 'lodash';
const StyledPointerOnHover = styled(PointerOnHover)`
  display: inline-block;
  width: 100%;
  &:hover {
    font-weight: normal;
  }
`;

class FileSelect extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "triggerInputFile", () => {
      this.fileInput.click();
    });

    _defineProperty(this, "render", () => {
      const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.slideshow', 'text/plain', 'text/css', 'application/pdf', 'image/*'];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hidden, null, /*#__PURE__*/React.createElement("input", {
        type: "file",
        accept: this.props.accept || _.join(allowedTypes, ', '),
        ref: fileInput => this.fileInput = fileInput,
        onChange: this.props.onSelectFile
      })), /*#__PURE__*/React.createElement(StyledPointerOnHover, {
        onClick: this.triggerInputFile
      }, this.props.children));
    });
  }

}

export default FileSelect;